module.exports = __webpack_public_path__ + "img/Assurplus.a3d5611a.svg";